import { Box, Card, CardContent, CardHeader, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { PieChart } from '@mui/x-charts/PieChart';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';

const data = [
    { id: 0, value: 25, label: 'Soğuk Cam-Sevkiyat' },
    { id: 1, value: 10, label: 'Fırın' },
    { id: 2, value: 20, label: 'Buzlucam' },
    { id: 3, value: 5, label: 'Makina Bakım Onarım' },
    { id: 4, value: 5, label: 'Muhasebe' },
    { id: 5, value: 20, label: 'Diğer..' },

]
const MuiDashboardEmployes = () => {
    return (

        <Card sx={{ height: 300, minWidth: 440 }}>
            <CardHeader
                subheader="Çalışan Sayıları"
                action={
                    <Tooltip title="Detay göster">
                        <IconButton>
                            <MoreHorizIcon />
                        </IconButton>
                    </Tooltip>
                }
                avatar={
                    <PeopleAltIcon />
                }
            />
            <CardContent>
                <Stack spacing={2} direction="row" >

                    <PieChart
                        series={[
                            {
                                data: data,
                                arcLabel: (item) => item.value.toString(),
                                innerRadius: 25,
                                outerRadius: 100,
                                paddingAngle: 3,
                                cornerRadius: 7,
                                startAngle: 0,
                                endAngle: 360,
                                cx: 100,
                                cy: 95,
                            }

                        ]}
                        // slotProps={{
                        //     legend: {
                        //         labelStyle: {
                        //             tableLayout: 'fixed',
                        //         },
                        //         direction: 'row',
                        //         position: {
                        //             horizontal: 'middle',
                        //             vertical: 'bottom',
                        //         },
                        //     },
                        // }}

                        height={200}
                    />
                    {/* <PieChart
                        series={[{ data: data, innerRadius: 70, outerRadius: 85 }]}
                        //colors={colors}
                        width={150}
                        height={150}
                        margin={{ right: 0, top: 0 }}
                        slotProps={{
                            legend: {
                                labelStyle: {
                                    tableLayout: 'fixed',
                                },
                                direction: 'row',
                                position: {
                                    horizontal: 'middle',
                                    vertical: 'bottom',
                                },
                            },
                        }}
                        sx={{}}
                    /> */}
                    {/* <Stack width={150} spacing={2} alignItems="center">
                        <Typography>İstihdam</Typography>
                        <Stack direction="row" spacing={4} justifyContent="space-around">
                            <PersonAddIcon />
                            <Typography variant="h3">5</Typography>
                        </Stack>
                        <Stack direction="row" spacing={4} justifyContent="space-between">
                            <PersonRemoveIcon />
                            <Typography variant="h3">3</Typography>
                        </Stack>
                        <Stack direction="row" spacing={4} justifyContent="space-between">
                            <PersonSearchIcon />
                            <Typography variant="h3">0</Typography>
                        </Stack>

                    </Stack> */}

                </Stack>
            </CardContent>

        </Card>



    )
}

export default MuiDashboardEmployes;